import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = {
  class: "dialog-plant-create__grid--even",
  style: {"gap":"2rem"}
}
const _hoisted_5 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_6 = { class: "px-3 py-1" }
const _hoisted_7 = { class: "p-field-label my-2" }
const _hoisted_8 = { style: {"margin":"0 -0.5rem"} }
const _hoisted_9 = {
  class: "checkbox-sublabel text-gray",
  style: {"font-size":"13px"}
}
const _hoisted_10 = {
  key: 0,
  class: "separator mt-2",
  style: {"background-color":"currentColor","opacity":"0.25"}
}
const _hoisted_11 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "text-gray mb-2" }
const _hoisted_15 = { class: "ml-auto" }
const _hoisted_16 = { class: "text-uppercase text-gray small" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "separator mt-3 mb-4",
  style: {"background-color":"currentColor","opacity":"0.25"}
}
const _hoisted_19 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildingConfigs, (building, buildingIndex) => {
                return (_openBlock(), _createBlock("div", {
                  key: buildingIndex,
                  class: "mb-4"
                }, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("label", {
                      class: "p-field-label mt-1",
                      for: `buildingName${buildingIndex}`
                    }, _toDisplayString(_ctx.$t("NameBuilding")) + " " + _toDisplayString(buildingIndex + 1), 9, ["for"]),
                    _createVNode(_component_InputText, {
                      id: `buildingName${buildingIndex}`,
                      type: "text",
                      modelValue: building.name,
                      "onUpdate:modelValue": ($event: any) => (building.name = $event),
                      class: "mb-3"
                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue"]),
                    _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.AssociateRisersBackboneWithBuilding")), 1),
                    _createVNode("div", _hoisted_8, [
                      _createVNode(_component_ListItemCheck, {
                        label: building.linkedRisersConfig[0].name,
                        value: building.linkedRisersConfig[0].id,
                        inputId: `uniqueBuilding${buildingIndex}Riser${building.linkedRisersConfig[0].id}`,
                        name: "riserLinkSelectionUnique",
                        modelValue: building.linkedRisersIds,
                        "onUpdate:modelValue": ($event: any) => (building.linkedRisersIds = $event),
                        disabled: "",
                        rowStyle: ""
                      }, {
                        "checkbox-sublabel": _withCtx(() => [
                          _createVNode("div", _hoisted_9, [
                            _createVNode("small", null, _toDisplayString(_ctx.subtitleComboModeLabel(building.linkedRisersConfig[0].interfaces.length)), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "value", "inputId", "modelValue", "onUpdate:modelValue"])
                    ])
                  ]),
                  (buildingIndex < _ctx.buildingConfigs.length - 1)
                    ? (_openBlock(), _createBlock("hr", _hoisted_10))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildingConfigs, (building, buildingIndex) => {
                return (_openBlock(), _createBlock("div", {
                  key: buildingIndex,
                  class: "mb-4"
                }, [
                  _createVNode("h6", _hoisted_12, _toDisplayString(building.name), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(building.linkedRisersConfig, (riser, riserId) => {
                    return (_openBlock(), _createBlock("div", { key: riserId }, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("div", _hoisted_14, _toDisplayString(riser.name), 1),
                        _createVNode("div", _hoisted_15, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(riser.interfaces, (intf, intfIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              key: intfIndex,
                              class: "mb-3 d-flex flex-column"
                            }, [
                              _createVNode("label", _hoisted_16, [
                                _createTextVNode(_toDisplayString(_ctx.$t('AppResourceEP.Apartments')), 1),
                                (!riser.isBackbone)
                                  ? (_openBlock(), _createBlock("span", _hoisted_17, " (" + _toDisplayString(_ctx.getInterfaceModeLabel(intf.mode)) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_InputText, {
                                modelValue: intf.numberOfApartments,
                                disabled: true,
                                class: "w-100"
                              }, null, 8, ["modelValue"])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  }), 128)),
                  (buildingIndex < _ctx.buildingConfigs.length - 1)
                    ? (_openBlock(), _createBlock("hr", _hoisted_18))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("footer", _hoisted_19, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        disabled: _ctx.isNextDisabled,
        label: _ctx.$t('AppResource.Finish'),
        class: "p-button-rounded p-button-raised p-button--m"
      }, null, 8, ["onClick", "disabled", "label"])
    ])
  ], 64))
}